import classes from "../login.module.scss";

import React from "react";
import { NavLink } from "react-router-dom";

import { ImageLazy } from "@app/components";

export const LoginHeader = () => {
  return (
    <div className={classes["header"]}>
      <NavLink to="/login">
        <ImageLazy
          sources={[
            {
              src: "https://res.cloudinary.com/hivery/image/upload/v1596433731/hivery-assets/Hivery_Curate_Logo_MONO_Horizontal_Pos.svg",
              alt: "Curate logo",
              classes: classes["login-logo"],
            },
          ]}
        />
      </NavLink>
    </div>
  );
};
